// Display-only formatting helpers. repair_number is stored as a plain
// INTEGER in the database (see CLAUDE.md) - leading zeros from the
// physical ticket book (e.g. "0007") are stripped by that type. This
// pads it back for display without touching the underlying value, so
// it always matches the ticket book format. Numbers with 4+ digits
// already are returned unchanged - padStart never truncates.
export function formatRepairNumber(repairNumber) {
  if (repairNumber === null || repairNumber === undefined || repairNumber === '') {
    return '';
  }
  return String(repairNumber).padStart(4, '0');
}